import { useState } from "react";
import PropTypes from "prop-types";
import {
  InputAdornment,
  IconButton,
  PropTypes as MuiPropTypes,
  TextField,
} from "@material-ui/core";
import { Visibility, VisibilityOff } from "@material-ui/icons";

type IProps = {
  id: string;
  value: any;
  name?: string;
  label: string;
  onChange: Function;
  fullWidth?: boolean;
  margin: MuiPropTypes.Margin;
};

const PasswordField = (props: IProps) => {
  const [showPassword, setShowPassword] = useState(false);

  const handleTogglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <TextField
      id={props.id}
      type={showPassword ? "text" : "password"}
      label={props.label}
      value={props.value}
      name={props.name}
      onChange={(ev) => props.onChange(ev)}
      autoComplete="off"
      fullWidth={props.fullWidth}
      margin={props.margin}
      InputProps={{
        endAdornment: (
          <InputAdornment position="end">
            <IconButton
              aria-label="Toggle password visibility"
              onClick={handleTogglePasswordVisibility}
            >
              {showPassword ? <Visibility /> : <VisibilityOff />}
            </IconButton>
          </InputAdornment>
        ),
      }}
    />
  );
};

PasswordField.propTypes = {
  id: PropTypes.string.isRequired,
  value: PropTypes.any.isRequired,
  name: PropTypes.string,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  fullWidth: PropTypes.bool,
  margin: PropTypes.oneOf(["none", "dense", "normal"]),
};

PasswordField.defaultProps = {
  margin: "none",
};

export default PasswordField;
